/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OwnerApproveOrRejectItemSubmittalCommand } from '../../models/owner-approve-or-reject-item-submittal-command';
import { OwnerApproveOrRejectItemSubmittalCommandResult } from '../../models/owner-approve-or-reject-item-submittal-command-result';

export interface ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Params {
  
    /**
     * The command to approve or reject a project item submittal.
     */
    body?: OwnerApproveOrRejectItemSubmittalCommand
}

export function apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OwnerApproveOrRejectItemSubmittalCommandResult>;
    })
  );
}

apiProjectItemSubmittalsOwnerApproveOrRejectProjectItemSubmittalPatch$Plain.PATH = '/api/ProjectItemSubmittals/OwnerApproveOrRejectProjectItemSubmittal';
